import { Auth_Check, file_Uploaddata, Step_Action, Refresh_Token,Customer_Config } from "./action"

// author check
export const dispatchAuth = (dispatch, isAuth, token, userInfo) => {
    dispatch({ type: Auth_Check, isAuth: isAuth, token: token, userInfo : userInfo });
};

export const dispatchCustomerConfig = (dispatch, cusConfig) => {
    dispatch({ type: Customer_Config, cusConfig: cusConfig });
};

export const dispatchRefreshToken = (dispatch, refreshToken) => {
    dispatch({ type: Refresh_Token, refreshToken: refreshToken  });
};

// file upload data
export const dispatchFileUpload = (dispatch, fileUploaddata) => {
    dispatch({ type: file_Uploaddata, fileUploaddata: fileUploaddata });
};

//step submit artical
export const dispatchStepAction = (dispatch, stepCounter) => {
    dispatch({ type: Step_Action, stepCounter: stepCounter });
};
